import MergeRecordingLogic from "../../components/RecordingFeatures/MergeRecording";

const MergeRecordingPage = () => {

    return (
        <div className="vr-edit-page">
            <MergeRecordingLogic />
        </div>
    );
};

export default MergeRecordingPage;
